<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_contact"
        :primary-fields="[ 'name', 'phone', 'mobile', 'email', 'include_billing', 'include_pickups' ]"
        @sort="sort = $event; $refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <ContactsTable
          ref="table"
          :account-id="$route.params.accountId"
          :filters="filters"
          :sort="sort"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import ContactsTable from '@/components/Application/Manage/Account/ContactsTable'

export default {
  components: {
    Filters,
    ContactsTable
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Contacts',
        route: { name: 'manage-accounts-account-contacts', params: { accountId: this.$route.params.accountId } }
      },
      filters: [],
      sort: { field: 'uuid', direction: 'asc' }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
